// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A9BH","expireSoon":"styles_expireSoon__1CAuS"};